import React from "react";
import clsx from "clsx";
import RightTick from "../../../assets/svg/right-tick.svg";
import { IStepper } from "./Stepper";

const Stepper: React.FunctionComponent<IStepper.IProps> = ({
  numberOfSteps,
  steps,
  activeStep,
  inactiveProgressbarClassname,
  activeProgressbarClassname,
  inactivePointsClassname,
  activePointsClassname,
}) => {
  return (
    <div
      id="progressbar"
      key={activeStep}
      className={clsx(
        "relative flex justify-between items-center before:content-[''] before:absolute before:top-1/2 before:-scale-y-50 before:h-1 before:w-full before:bg-[#C4C4C4] before:z-10 before:-mt-0.5",
        inactiveProgressbarClassname
      )}
    >
      <div
        id="progress"
        style={{ width: `${(100 / (numberOfSteps - 1)) * (activeStep - 1)}%` }}
        className={clsx(
          "content-[''] absolute top-1/2 -scale-y-50 h-1 bg-[#1BC02B] z-10 -mt-0.5",
          activeProgressbarClassname
        )}
      ></div>
      {steps.map((step, idx) => {
        return idx >= activeStep ? (
          <div
            id="progress-step"
            className={clsx(
              "relative w-4 h-4 rounded-2xl after:content-[attr(data-title)] after:w-max after:absolute after:text-xs after:top-[calc(100%_+_10px)] after:-left-1/2  bg-[#C4C4C4] z-20",
              inactivePointsClassname
            )}
            data-title={step}
          />
        ) : (
          <div
            id="progress-step"
            className={clsx(
              "relative w-6 h-6 rounded-2xl after:content-[attr(data-title)] after:w-max after:absolute after:text-xs after:top-[calc(100%_+_10px)] after:-left-3/4 bg-[#1BC02B] z-20",
              activePointsClassname
            )}
            style={{
              backgroundImage: `url(${RightTick})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
            data-title={step}
          />
        );
      })}
    </div>
  );
};

export default Stepper;
